import {RootState} from 'app/rootReducer'
import {
  AnalyticsSearchQueryParams,
  ProductivitySearchInputState,
  OverviewSearchInputState,
  RESOURCE_TYPE,
  RESOURCE_TYPE_SINGULAR,
  SearchSuggestion,
  ShadowITFilter,
  GetAnalyticsDetailRequestPayload,
  AnalyticsDetailState,
  POLICY_TYPE,
} from 'interfaces'
import {StateObservable} from 'redux-observable'

export const parseSearchParamsFromSuggestion = (
  suggestion: SearchSuggestion,
): ProductivitySearchInputState | ShadowITFilter | OverviewSearchInputState => {
  const {resourceType} = suggestion
  let searchType
  let searchTerm
  let searchDisplayValue
  let name
  if (resourceType === RESOURCE_TYPE.Users) {
    searchType = RESOURCE_TYPE_SINGULAR.User
    searchDisplayValue = searchTerm =
      suggestion?.emailId || suggestion?.displayValue
    name = suggestion?.name || ''
  } else if (resourceType === RESOURCE_TYPE.Groups) {
    searchType = RESOURCE_TYPE_SINGULAR.Group
    searchDisplayValue = searchTerm = suggestion?.emailId || ''
    name = suggestion?.name || ''
  } else {
    searchType = RESOURCE_TYPE_SINGULAR.Location
    searchTerm = suggestion?.searchTerm
    searchDisplayValue = suggestion?.displayValue
    name = ''
  }

  return {
    searchTerm,
    searchDisplayValue,
    searchType,
    name,
    filterUpdated: true,
  }
}

export const getAnalyticsSearchQueryParams = (
  state: ProductivitySearchInputState,
): AnalyticsSearchQueryParams => {
  const {searchTerm, searchType} = state || {}
  if (searchTerm && searchType) {
    return {
      search_type: searchType,
      search: searchTerm,
    }
  } else {
    return {} as AnalyticsSearchQueryParams
  }
}

export const parseAnalyticsDetailRequestPayload = (
  state$: StateObservable<RootState>,
): GetAnalyticsDetailRequestPayload => {
  const ad: AnalyticsDetailState = state$?.value?.analyticsDetail
  const reqPayload = getAnalyticsDetailRequestPayload(ad)

  return reqPayload
}

export const getAnalyticsDetailRequestPayload = (
  ad: AnalyticsDetailState,
): GetAnalyticsDetailRequestPayload => {
  let reqPayload = {} as GetAnalyticsDetailRequestPayload
  if (ad?.policyType?.length !== Object.values(POLICY_TYPE).length) {
    reqPayload = {
      filter: {
        policyType: ad.policyType,
      },
    }
  }
  if (ad?.resourceType?.length) {
    reqPayload = {
      ...reqPayload,
      filter: {
        ...reqPayload?.filter,
        resourceType: ad.resourceType,
      },
    }
  }
  if (Object.keys(ad?.filterDetails).length) {
    reqPayload = {
      ...reqPayload,
      filter: {
        ...reqPayload?.filter,
        filterDetails: ad.filterDetails,
      },
    }
  }
  if (ad?.sortAscending) {
    reqPayload = {
      ...reqPayload,
      sortAscending: ad.sortAscending,
    }
  }

  return reqPayload
}
